import { IRoutes } from "@techzyapp/ui-lib";
import { injectAccessKeys } from "utils/helpers/routes";
import { ROUTE_ACCESS_MAP } from "utils/constants/accessKeys";

// Auth Routes
import { LoginRoute } from "pages/Login/routes";
import { ForgotPasswordRoute } from "pages/ForgotPassword/routes";
import { ResetPasswordRoute } from "pages/ResetPassword/routes";
import { SetPasswordRoute } from "pages/SetPassword/routes";

// Account Routes
import { AccountRoute } from "pages/Account/routes";

// System Users
import { SystemUsersRoute } from "pages/SystemUsers/routes";

// Mall
import { MallRoute } from "pages/Mall/routes";

// Brands
import { BrandsCategoriesRoute } from "pages/BrandCategories/routes";
import { BrandsMainPageRoute } from "pages/BrandsMainPage/routes";
import { BrandsRoute } from "pages/BrandsListing/routes";
import { PremiumMainPageRoute } from "pages/Premium/routes";
import { FoodMainPageRoute } from "pages/Food/routes";

// Audit Logs
import { AuditLogsRoute } from "pages/AuditLogs/routes";

// Default SEO
import { DefaultSeoRoute } from "pages/DefaultSeo/routes";

// Sitemap & Robots
import { SitemapRoute, RobotsRoute } from "pages/Sitemap/routes";

// Offers
import { OffersMainPageRoute } from "pages/OffersMainPage/routes";
import { OffersRoute } from "pages/OffersListing/routes";

// Cashback
import { CashbackMainPageRoute } from "pages/CashbackMainPage/routes";
import { CashbackRoute } from "pages/CashbackListing/routes";

// News
import { NewsMainPageRoute } from "pages/NewsMainPage/routes";
import { NewsRoute } from "pages/NewsListing/routes";

// Vacancy
import { VacancyMainPageRoute } from "pages/VacancyMainPage/routes";
import { VacancyRoute } from "pages/VacancyListing/routes";

// Services
import { ServicesMainPageRoute } from "pages/ServicesMainPage/routes";
import { ServicesRoute } from "pages/ServiceListing/routes";

// Reviews
import { ReviewsMainPageRoute } from "pages/ReviewsMainPage/routes";
import { ReviewsRoute } from "pages/ReviewsListing/routes";

// Map
import { MapMainPageRoute } from "pages/MapMainPage/routes";
import { MapFloorRoute } from "pages/MapFloors/routes";
import { MapPinRoute } from "pages/MapPins/routes";

// Text Pages
import { PrivacyPolicyPageRoute } from "pages/PrivacyPolicy/routes";
import { CookiesPolicyPageRoute } from "pages/CookiesPolicy/routes";
import { AdditionalInformationPageRoute } from "pages/AdditionalInformation/routes";
import { CityTowerPageRoute } from "pages/CityTower/routes";
import { MagicCityPageRoute } from "pages/MagicCity/routes";

// Card
import { CardsMainPageRoute } from "pages/GiftCardMainPage/routes";
import { CardsRoute } from "pages/GiftCardListing/routes";
import { GeneralPageRoute } from "pages/General/routes";
import { ContactPageRoute } from "pages/Contact/routes";
import { TermsAndConditionsPageRoute } from "pages/TermsAndConditions/routes";
import { LoyaltyUserTermsAndConditionsPageRoute } from "pages/LoyaltyUserTermsAndConditions/routes";
import { CityMallCardPageRoute } from "pages/CityMallCard/routes";
import { LoyaltyCardsRoute } from "pages/LoyaltyCard/routes";
import { LoyaltyBenefitsRoute } from "pages/LoyaltyBenefits/routes";

// Homepage
import { homeMainPageRoute } from "pages/HomeMainPage/routes";
import { HomePageSliderRoute } from "pages/HomepageSlider/routes";
import { HomepageBrandsRoute } from "pages/HomepageBrands/routes";
import { HomepageEventsRoute } from "pages/HomepageEvents/routes";
import { SpecialEventRoute } from "pages/SpecialEvent/routes";

// Landing Page
import { LandingPageRoute } from "pages/LandingPage/routes";

const rawRoutes: IRoutes = {
  mainPath: "/",
  defaultPath: SystemUsersRoute.path,
  indexElement: SystemUsersRoute.element,
  items: [
    {
      name: "Core",
      path: "/core",
      element: "",
      children: [
        SystemUsersRoute,
        AuditLogsRoute,
        DefaultSeoRoute,
        SitemapRoute,
        RobotsRoute,
        GeneralPageRoute,
        ContactPageRoute,
      ],
    },
    {
      name: "Pages",
      path: "/pages",
      element: "",
      children: [
        MallRoute,
        LandingPageRoute,
        {
          name: "Homepage",
          path: "pages/homepage",
          element: "",
          children: [
            homeMainPageRoute,
            HomePageSliderRoute,
            HomepageBrandsRoute,
            HomepageEventsRoute,
            SpecialEventRoute,
          ],
        },
        {
          name: "Brand Pages",
          path: "/pages/brands",
          element: "",
          children: [
            PremiumMainPageRoute,
            FoodMainPageRoute,
            BrandsMainPageRoute,
            BrandsRoute,
            BrandsCategoriesRoute,
          ],
        },
        {
          name: "Offer Pages",
          path: "/pages/offers",
          element: "",
          children: [OffersRoute, OffersMainPageRoute],
        },
        {
          name: "Cashback Pages",
          path: "/pages/cashback",
          element: "",
          children: [CashbackRoute, CashbackMainPageRoute],
        },
        {
          name: "News Pages",
          path: "/pages/news",
          element: "",
          children: [NewsRoute, NewsMainPageRoute],
        },
        {
          name: "Vacancy Pages",
          path: "/pages/vacancy",
          element: "",
          children: [VacancyRoute, VacancyMainPageRoute],
        },
        {
          name: "Service Pages",
          path: "/pages/services",
          element: "",
          children: [ServicesRoute, ServicesMainPageRoute],
        },
        {
          name: "Review Pages",
          path: "/pages/reviews",
          element: "",
          children: [ReviewsRoute, ReviewsMainPageRoute],
        },
        {
          name: "Gift Card Pages",
          path: "/pages/cards",
          element: "",
          children: [CardsRoute, CardsMainPageRoute, CityMallCardPageRoute],
        },
        LoyaltyCardsRoute,
        LoyaltyBenefitsRoute,
        {
          name: "Map Pages",
          path: "/pages/map",
          element: "",
          children: [MapMainPageRoute, MapFloorRoute, MapPinRoute],
        },
        PrivacyPolicyPageRoute,
        CookiesPolicyPageRoute,
        TermsAndConditionsPageRoute,
        LoyaltyUserTermsAndConditionsPageRoute,
        AdditionalInformationPageRoute,
        CityTowerPageRoute,
        MagicCityPageRoute,
      ],
    },

    AccountRoute,
  ],
};

export const allRoutes = injectAccessKeys(rawRoutes, ROUTE_ACCESS_MAP);

export const authRoutes: IRoutes = {
  mainPath: "/",
  defaultPath: LoginRoute.path,
  indexElement: LoginRoute.element,
  items: [
    LoginRoute,
    ForgotPasswordRoute,
    ResetPasswordRoute,
    SetPasswordRoute,
  ],
};
